import { errorPlayerContainerNotCreated } from './errors';
import { tafMediaTrackRolesAsSdk } from './utils';
export const playerSetSubtitlesTrack = (container, parameters) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    const track = parameters.track;
    if (track) {
        player.setSubtitlesTrack({
            codec: track.codec,
            locale: track.locale,
            id: track.id,
            roles: tafMediaTrackRolesAsSdk(track.rolesWrapper),
        });
    }
    else {
        player.setSubtitlesTrack(null);
    }
};
